import React from "react";
import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import "./AboutUsPage.css"; // Import CSS
import Layout from "../layout/Layout";

const AboutUsPage = () => {
  return (
    <Box>
      <Layout>
        <Box className="about-container">
          <Box className="about-content">
            {/* Header Section */}
            <Box className="about-header">
              <Typography className="about-header-title">من نحن</Typography>
            </Box>

            {/* Content Container */}
            <Box className="about-text-container">
              {/* First Section */}
              <Box>
                <Typography className="about-text">
                  نحن في “يلا فلة” شركة سعودية مسجلة رسميًا لدى وزارة التجارة،
                  نعمل برؤية مستقبلية تتماشى مع أهداف رؤية المملكة 2030 لتعزيز
                  القطاع السياحي ودعم تجربة السياح من جميع أنحاء العالم. تأسس
                  تطبيق “يلا فلة” بهدف أن يكون الرفيق المثالي للسياح داخل
                  المملكة العربية السعودية، حيث نقدم حلولاً ذكية تجعل استكشاف
                  المملكة تجربة سهلة، ممتعة، ومليئة بالفوائد.
                </Typography>
              </Box>
              {/* رؤيتنا */}
              <Box>
                <Typography className="about-subtitle">رؤيتنا:</Typography>
                <Typography className="about-paragraph">
                  أن نكون الخيار الأول للسياح الذين يتطلعون لاكتشاف سحر المملكة
                  العربية السعودية وتجاربها المتنوعة، من خلال تقديم خدمات سياحية
                  مبتكرة تعتمد على الذكاء الصناعي لخلق تجربة سياحية مصممة حسب
                  احتياجات كل فرد.
                </Typography>
              </Box>
              {/* رسالتنا */}
              <Box className="about-section">
                <Typography className="about-subtitle">رسالتنا:</Typography>
                <Typography className="about-paragraph">
                  نسعى إلى جعل السياحة داخل المملكة تجربة غنية وسهلة المنال من
                  خلال:
                </Typography>
                <List className="about-list about-numbered">
                  <ListItem>
                    <ListItemText primary="تقديم جميع الفعاليات والخدمات السياحية في مكان واحد." />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="استخدام التكنولوجيا الذكية لفهم تفضيلات السياح ومساعدتهم على اختيار الأنشطة التي تناسبهم." />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="بناء مجتمع من الشراكات مع مزودي الخدمات السياحية لتقديم أفضل العروض وأعلى مستوى من الجودة." />
                  </ListItem>
                </List>
              </Box>
              {/* ماذا نقدم؟ */}
              <Box className="about-section">
                <Typography className="about-subtitle">ماذا نقدم؟</Typography>
                <List className="about-list about-numbered">
                  <ListItem>
                    <ListItemText
                      primary="تجربة سياحية شاملة:"
                      secondary="في “يلا فلة”، يمكنك العثور على جميع الفعاليات السياحية، من الجولات الثقافية إلى المغامرات الترفيهية والفعاليات العائلية، كل ذلك من خلال تطبيق واحد سهل الاستخدام."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="ذكاء صناعي لتوصيات شخصية:"
                      secondary="باستخدام تقنيات الذكاء الصناعي، يساعدك التطبيق على اختيار الأنشطة التي تناسب ميزانيتك واهتماماتك، مما يضمن لك تجربة سياحية مثالية تلبي تطلعاتك."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="سهولة الحجز والدفع:"
                      secondary="وفر وقتك ومجهودك مع خدماتنا التي تتيح لك حجز الفعاليات بكل سهولة عبر التطبيق والدفع بطريقة آمنة ومريحة."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="شراكات استراتيجية:"
                      secondary="نحن نعمل مع مجموعة واسعة من مزودي الخدمات السياحية لضمان تقديم خيارات متنوعة وتجارب استثنائية لجميع زوار المملكة."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="دعم مستمر:"
                      secondary="لأنك تستحق أفضل تجربة، فإن فريق دعم العملاء لدينا متوفر على مدار الساعة للإجابة عن استفساراتك وتقديم المساعدة."
                    />
                  </ListItem>
                </List>
              </Box>
              {/* أهدافنا */}
              <Box className="about-section">
                <Typography className="about-subtitle">أهدافنا:</Typography>
                <List className="about-list about-numbered">
                  <ListItem>
                    <ListItemText
                      primary="تعزيز السياحة في المملكة:"
                      secondary="نطمح إلى أن نكون جزءًا من النمو المستمر للقطاع السياحي من خلال جذب السياح وتسهيل اكتشافهم للكنوز السياحية في المملكة."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="تقديم قيمة مضافة للسياح ومزودي الخدمات:"
                      secondary="نسعى لإثراء تجربة السياح، مع تقديم فرص للشركات المحلية لعرض خدماتها على نطاق أوسع."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="الابتكار والتطوير:"
                      secondary="نعمل باستمرار على تحسين خدماتنا وإضافة ميزات جديدة تعتمد على أحدث تقنيات الذكاء الصناعي."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="الاستدامة السياحية:"
                      secondary="ندعم الأنشطة السياحية التي تساهم في الحفاظ على الموارد الطبيعية والثقافية للمملكة."
                    />
                  </ListItem>
                </List>
              </Box>
              {/* لماذا نحن؟ */}
              <Box className="about-section">
                <Typography className="about-subtitle">لماذا نحن؟</Typography>
                <List className="about-list about-bullets">
                  <ListItem>
                    <ListItemText
                      primary="واجهة مستخدم سهلة ومبتكرة:"
                      secondary="التطبيق مصمم ليكون بسيطًا وسريعًا."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="توصيات مخصصة:"
                      secondary="كل تجربة يتم تصميمها لتناسب احتياجاتك."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="أسعار تنافسية:"
                      secondary="نوفر لك أفضل الصفقات على الأنشطة والفعاليات."
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="شركاء نجاح:"
                      secondary="نحن نعتبر مزودي الخدمات شركاء لنا، ونعمل على تقديم تجربة استثنائية للجميع."
                    />
                  </ListItem>
                </List>
                <Typography className="about-paragraph">
                  في “يلا فلة”، نحن أكثر من مجرد تطبيق. نحن شركاؤك في استكشاف
                  المملكة وتجربة أروع لحظاتها. سواء كنت تبحث عن المغامرة،
                  الاسترخاء، أو التعرف على التراث الثقافي للمملكة، نحن هنا لنكون
                  دليلك. انطلق في رحلتك معنا، لأن الفلة تبدأ هنا!
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Footer */}
        </Box>
      </Layout>
    </Box>
  );
};

export default AboutUsPage;
